<template>
    <div class="col">
        <slot></slot>
    </div>
</template>

<script>
    export default {
        name: "Col"
    }
</script>

<style lang="scss" scoped>

</style>
